import Vue from 'vue'
import Vuex from 'vuex'
import * as api from '@/services/pos'
import utilities from '@/services/utilities'
import moment from 'moment'
import numeral from 'numeral'
import * as facturapi from '@/services/facturapi'

const dateFormat = 'YYYY-MM-DD'

Vue.use(Vuex)

export default {
	namespaced: true,
	state: {
		spinnerLoader: false,
		spinnerLoaderLabel: '',
		filters: {
			defaultDate: [moment().format(dateFormat), moment().format(dateFormat)],
			cashier: null,
			paymentMethod: [],
			branchOffice: [],
			ticket: '',
		},
		ticketList: [],
		advancesList: [],
		totals: {
			service: 0,
			boutique: 0,
			spareParts: 0,
			advances: 0,
		},
		actualTicket: {},
		earnings: 0,
		salesCosts: 0,
		//
		tickets: [],
		bankTerminalOperations: {
			rls: {
				credit: 0,
				debit: 0,
				paymentMethods: {
					cash: 0,
					transfer: 0,
					paypal: 0,
					mercadopago: 0,
				},
				canceled: {
					credit: 0,
					debit: 0,
					paymentMethods: {
						cash: 0,
						transfer: 0,
						paypal: 0,
						mercadopago: 0,
						aplazo: 0,
					},
				},
			},
			pacific: {
				credit: 0,
				debit: 0,
				paymentMethods: {
					cash: 0,
					transfer: 0,
					paypal: 0,
					mercadopago: 0,
					aplazo: 0,
				},
				canceled: {
					credit: 0,
					debit: 0,
					paymentMethods: {
						cash: 0,
						transfer: 0,
						paypal: 0,
						mercadopago: 0,
						aplazo: 0,
					},
				},
			},
		},
	},
	mutations: {
		SET_STATE(state, payload) {
			Object.assign(state, {
				...payload,
			})
		},
	},
	actions: {
		RESET_ONE_FILTER({ commit, dispatch, state }, key) {
			let filters = {
				...state.filters,
			}

			if (key == 'defaultDate') {
				filters.defaultDate = [moment().format(dateFormat), moment().format(dateFormat)]
			} else if (key == 'paymentMethod' || key == 'branchOffice') {
				filters[key] = []
			} else {
				filters[key] = 'Todos'
			}

			commit('SET_STATE', {
				filters,
			})
		},
		async GET_TICKETS({ commit }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Obteniendo información',
			})

			return new Promise((resolve, reject) => {
				api
					.getTickets(payload)
					.then((response) => {
						// console.log('GET_TICKETS-->', response)
						resolve(utilities.objectValidate(response, 'data', {}))
					})
					.catch((error) => {
						Vue.prototype.$notification.error({
							message: 'Ordenes de Compra',
							description: utilities.objectValidate(error, 'response.data.message', 'Error al consultar el servicio'),
						})
						reject(error)
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
		GET_ONE_TICKET({ commit }, id) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Obteniendo información',
			})
			api
				.getOneTicket(id)
				.then((response) => {
					commit('SET_STATE', {
						actualTicket: _.cloneDeep(response.data),
					})
				})
				.catch((error) => {
					Vue.prototype.$notification.error({
						message: 'Ordenes de Compra',
						description: utilities.objectValidate(error, 'response.data.message', 'Error al consultar el servicio'),
					})
				})
				.finally(() => {
					commit('SET_STATE', {
						spinnerLoader: false,
					})
				})
		},
		DOWNLOAD_INVOICE({ commit }, id) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Obteniendo datos...',
			})

			facturapi
				.downloadPDF(id)
				.then((response) => {
					window.open(`${process.env.VUE_APP_API_URL}/${response.data}`)
				})
				.catch((error) => {
					Vue.prototype.$notification.error({
						message: 'Caja',
						description: utilities.objectValidate(error, 'response.data.message', 'Error al obtener la factura'),
					})
				})
				.finally(() => {
					commit('SET_STATE', {
						spinnerLoader: false,
					})
				})
		},
		REQUEST_AUTHORIZATION({ commit }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Confirmando...',
			})
			return new Promise((resolve, reject) => {
				api
					.requestAuthorization(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						reject(utilities.objectValidate(error, 'response.data.message', 'Contraseña inválida.'))
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
		async CLOSE_ADVANCE({ commit }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Confirmando...',
			})
			return new Promise((resolve, reject) => {
				api
					.closeAdvanceTicket(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						reject(utilities.objectValidate(error, 'response.data.message', 'Contraseña inválida.'))
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
		async GET_PDF_REPORT({ commit }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Obteniendo reporte...',
			})
			return new Promise((resolve, reject) => {
				api
					.getPDFReport(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						reject(utilities.objectValidate(error, 'response.data.message', 'Error al obtener el reporte.'))
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
		async GET_PRODUCTIVITY_REPORT({ commit }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Obteniendo reporte...',
			})
			return new Promise((resolve, reject) => {
				api
					.getProductivityReport(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						reject(utilities.objectValidate(error, 'response.data.message', 'Error al obtener el reporte.'))
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
		async GET_SALES_REPORT({ commit }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Obteniendo reporte...',
			})
			return new Promise((resolve, reject) => {
				api
					.getSalesReport(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						reject(utilities.objectValidate(error, 'response.data.message', 'Error al obtener el reporte.'))
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
		/**
		 * Obtiene los ingresos por dropshipping
		 * @param {Object} payload - Filtros de consulta
		 * @param {string} payload.fecha_desde - Fecha desde (YYYY-MM-DD)
		 * @param {string} payload.fecha_hasta - Fecha hasta (YYYY-MM-DD)
		 * @returns {Promise}
		 */
		async GET_DROPSHIPPING_REVENUE({ commit }, payload) {
			return new Promise((resolve, reject) => {
				api
					.getDropshippingRevenue(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						Vue.prototype.$notification.error({
							message: 'Dropshipping',
							description: utilities.objectValidate(error, 'response.data.message', 'Error al consultar los ingresos de dropshipping'),
						})
						reject(error)
					})
			})
		},
		/**
		 * Obtiene los ingresos por Shopify
		 * @param {Object} payload - Filtros de consulta
		 * @param {string} payload.fecha_desde - Fecha desde (YYYY-MM-DD)
		 * @param {string} payload.fecha_hasta - Fecha hasta (YYYY-MM-DD)
		 * @returns {Promise}
		 */
		async GET_SHOPIFY_REVENUE({ commit }, payload) {
			return new Promise((resolve, reject) => {
				api
					.getShopifyRevenue(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						Vue.prototype.$notification.error({
							message: 'Shopify',
							description: utilities.objectValidate(error, 'response.data.message', 'Error al consultar los ingresos de Shopify'),
						})
						reject(error)
					})
			})
		},
	},
	getters: {
		filters: (state) => state.filters,
		ticketList: (state) => state.ticketList,
		actualTicket: (state) => state.actualTicket,
		advancesList: (state) => state.advancesList,
		spinnerLoader: (state) => state.spinnerLoader,
		spinnerLoaderLabel: (state) => state.spinnerLoaderLabel,
		earnings: (state) => {
			let total = 0
			state.ticketList.map((e) => {
				let cart = JSON.parse(e.cart)
				cart.map((el) => {
					total += (numeral(el.product.normal_price).value() - numeral(el.product.unit_cost).value()) * el.quantity
				})
			})
			return total
		},
		salesCosts: (state) => {
			let total = 0
			state.ticketList.map((e) => {
				let cart = JSON.parse(e.cart)
				cart.map((el) => {
					// sólo se considera en la sumatoria el valor de productos y no de servicios
					if (el.product.measurement_unit == 'H87') {
						total += numeral(el.product.unit_cost).value() * el.quantity
					}
				})
			})
			return total
		},
		totals: (state) => state.totals,
		tickets: (state) => state.tickets,
		bankTerminalOperations: (state) => state.bankTerminalOperations,
	},
}
